/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getRecordOfSupAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_rec_of_sup_assessments`,
    payload,
    callback
  );

export const getSingleRecordOfSupAssessment = (id, recordofSupAssessmentId, payload, callback) =>
  req.item(
    c.GET_SINGLE_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_rec_of_sup_assessments/${recordofSupAssessmentId}`,
    payload,
    callback
  );

export const createRecordOfSupAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_rec_of_sup_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateRecordOfSupAssessment = (id, recordofSupAssessmentId, payload, callback) =>
  req.update(
    c.UPDATE_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_rec_of_sup_assessments/${recordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRecordOfSupAssessment = (id, recordofSupAssessmentId, payload, callback) =>
  req.remove(
    c.REMOVE_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_rec_of_sup_assessments/${recordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

  export const getHistoryRecordofSupAssessmentList = (id, payload, callback) =>
    req.list(
      c.GET_HISTORY_RECORD_OF_SUP_ASSESSMENT,
      `/api/v1/rpt/administrator/buildings/building_history_logs/${id}/building_rec_of_sup_assessments`,
      payload,
      callback
    );